import {
  Actions,
  Subjects,
  useIsRbacEnabled,
  useIsTeamMultiSeat,
  useUserAbilitiesContext,
} from 'context/user/UserContext';

export const useCanReadFolders = () => {
  const isTeamUser = useIsTeamMultiSeat();
  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();

  const canReadFoldersLegacy = isTeamUser;
  const canReadFolders = isRbacEnabled
    ? ability.can(Actions.Read, Subjects.Folders)
    : canReadFoldersLegacy;
  return canReadFolders;
};

export const useCanCreateFolders = () => {
  const isTeamUser = useIsTeamMultiSeat();
  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();

  const canReadFoldersLegacy = isTeamUser;
  const canReadFolders = isRbacEnabled
    ? ability.can(Actions.Create, Subjects.Folders)
    : canReadFoldersLegacy;
  return canReadFolders;
};

export default { useCanReadFolders, useCanCreateFolders };
